import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { GetPrioritySnapshotsQuery } from './get-priority-snapshots.query';
import { GetPrioritySnapshotsResult } from './get-priority-snapshots.result';

/**
 * Get priority snapshots use case.
 * Retrieves available priority options for a case.
 */
@Injectable({ providedIn: 'root' })
export class GetPrioritySnapshotsUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(query: GetPrioritySnapshotsQuery): Observable<GetPrioritySnapshotsResult> {
    this._state.setLoadingPrioritySnapshots(true);
    this._state.setErrorPrioritySnapshots(null);

    return this._repository.getPrioritySnapshots(query.caseId).pipe(
      tap((prioritySnapshots) => {
        this._state.setPrioritySnapshots(prioritySnapshots);
        this._state.setLoadingPrioritySnapshots(false);
      }),
      map((prioritySnapshots) => ({ prioritySnapshots })),
      catchError((error) => {
        this._state.setErrorPrioritySnapshots(error.message || 'Failed to get priority snapshots');
        this._state.setLoadingPrioritySnapshots(false);
        return throwError(() => error);
      })
    );
  }
}
